const EMPTY_ARRAY = [];
const EMPTY_OBJECT = {};

export const getAuthenticating = (state) => state.authenticating;

export const getDataWindow = (state) => state.dataWindow;

export const getDataWindowDuration = (state) => state.dataWindow.duration;

export const getDrawerOpen = (state) => state.drawerOpen;

export const getFacilities = (state) => state.facilities.items;

export const getIsAuthenticated = (state) => state.isAuthenticated;

export const getLoading = (state) => state.loading;

export const getOrganizations = (state) => state.organizations.items;

export const getSites = (state) => state.sites;

export const getUpdates = (state) => state.updates;

export const getUser = (state) => state.user;

export const getUserInfo = (state) => state.userInfo;

export const getSelectedOrganization = (state) =>
  state.organizations.items.find((o) => o.selected);

export const getUserInvites = (state) => state.userInfo?.invites || EMPTY_ARRAY;

export const getFutureForecastHourlyData = (state) =>
  state.futureForecast?.hourly?.data || EMPTY_ARRAY;

export const getEventItems = (state) => state.events.Items || EMPTY_ARRAY;

export const getEvents = (state) => state.events;

export const getLastSeenEventTime = (state) => state.events.lastSeen;

export const getFutureForecast = (state) => state.futureForecast;

export const getReportsEntity = (state) => state.reports;

export const getShadows = (state) => state.shadows;

export const getWetWeatherEventItems = (state) =>
  state.wwes.Items || EMPTY_ARRAY;

export const getFacilityUpdates = (state, facilityId) =>
  state.updates[facilityId] || EMPTY_ARRAY;

export const getOrganizationUsers = (state, orgId) =>
  state.organizations?.users?.[orgId] || EMPTY_ARRAY;

export const getOrganizationInvites = (state, orgId) =>
  state.organizations?.invites?.[orgId] || EMPTY_ARRAY;

export const getCurrentUserInfo = (state) => state.userInfo || EMPTY_OBJECT;

export const getFacilityById = (state, facilityId) =>
  state.facilities.items.find((f) => f.facilityId === facilityId);

export const getOrganizationById = (state, orgId) =>
  state.organizations.items.find((o) => o.org_id === orgId);

export const getFacilityMetadata = (state, facilityId) =>
  state.facilities.metadata[facilityId] || EMPTY_OBJECT;

export const getFacilityShadow = (state, facilityId) =>
  state.shadows[facilityId];

export const getFacilityWetWeatherEvents = (state, facilityId) =>
  state.wwes[facilityId] || EMPTY_ARRAY;

export const selectFacilityById = (facilityId) => (state) =>
  getFacilityById(state, facilityId);

export const selectOrganizationById = (orgId) => (state) =>
  getOrganizationById(state, orgId);

export const selectFacilityUpdates = (facilityId) => (state) =>
  getFacilityUpdates(state, facilityId);

export const selectOrganizationUsers = (orgId) => (state) =>
  getOrganizationUsers(state, orgId);

export const selectOrganizationInvites = (orgId) => (state) =>
  getOrganizationInvites(state, orgId);

export const selectFacilityMetadata = (facilityId) => (state) =>
  getFacilityMetadata(state, facilityId);

export const selectFacilityShadow = (facilityId) => (state) =>
  getFacilityShadow(state, facilityId);

export const selectFacilityWetWeatherEvents = (facilityId) => (state) =>
  getFacilityWetWeatherEvents(state, facilityId);

export const getLastUpdate = (state, facility) => {
  if (state.updates && state.updates[facility.facilityId]) {
    return state.updates[facility.facilityId][0];
  }
  return {};
};

export const getSiteOfFacility = (state, facilityId) => {
  const facility = state.facilities.items.find(
    (f) => f.facilityId === facilityId
  );
  if (facility) {
    return state.sites.find((site) => site.site_id === facility.siteId);
  }
  return null;
};
